// extracted by mini-css-extract-plugin
export default {"root":"rangeDatePicker_root__dkSNg","page":"rangeDatePicker_page__xktHs","container":"rangeDatePicker_container__Ms62b","dayPicker":"rangeDatePicker_dayPicker__aZKkp"};